import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import type { CalibrationRuntimeData } from '@features/calibration/hooks/useCalibrationRuntime/types';
import { BasicReadingTestSection } from '@features/calibration/components/testWrappers';

type Props = {
  calibrationData: CalibrationRuntimeData;
};

const HistoryCalibrationTests: React.FC<Props> = ({ calibrationData }) => {
  const { t } = useTranslation('calibration');
  const [basicReadingExpanded, setBasicReadingExpanded] = useState(true);

  return (
    <Box sx={{ mt: 3 }}>
      <Box sx={{ mb: 3, display: 'flex', alignItems: 'center', gap: 2 }}>
        <Typography
          variant="h5"
          sx={{ color: 'primary.main', fontWeight: 'medium', mb: 0 }}
        >
          {t('section.title')}
        </Typography>
      </Box>

      <BasicReadingTestSection
        testData={calibrationData.tests?.basicReading}
        isReadOnly={true}
        expanded={basicReadingExpanded}
        onExpandedChange={setBasicReadingExpanded}
      />
    </Box>
  );
};

export default HistoryCalibrationTests;
